var map = {
	"./ar/common.json": 2323,
	"./de/common.json": 1447,
	"./en/adhd/common.json": 6625,
	"./en/common.json": 6115,
	"./en/smalltalk/common.json": 6865,
	"./es/common.json": 9666,
	"./es/smalltalk/common.json": 268,
	"./fr/common.json": 362,
	"./ru/common.json": 7685,
	"./uk/common.json": 1754
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 3705;